import moment from "moment";
import { checkStatusExpiry } from "../common/checkStatusExpiry";
import StatusEnum from "../common/StatusEnum";

export const getBeaconDataAPI = async (dynamoDBClient, id = "", email = "") => {
  const batchParams = {
    RequestItems: {
      BeaconData: {
        Keys: [
          {
            Email: email,
            BeaconMAC: id,
          },
        ],
        ProjectionExpression: "Battery , DateUpdated, Email, SignalStrength",
      },
      Beacons: {
        Keys: [
          {
            Email: email,
            BeaconMAC: id,
          },
        ],
        ProjectionExpression: "BeaconLocation, BeaconMAC, Firmware, QRCode",
      },
    },
  };

  try {
    const data2 = await dynamoDBClient.batchGet(batchParams).promise();
    const result1 = data2.Responses.BeaconData[0];
    const result2 = data2.Responses.Beacons[0];

    if (result2) {
      let status;
      if (result1) {
        const isGreaterTime = checkStatusExpiry(result1.DateUpdated);
        if (isGreaterTime) {
          status = StatusEnum.offline;
        } else {
          status = StatusEnum.online;
        }
      } else {
        status = StatusEnum.offline;
      }
      let finalResult = [];
      if (result1) {
        finalResult = [
          {
            ...result2,
            status,
            Battery: result1.Battery,
            Email: result1.Email,
            signal: +result1.SignalStrength,
          },
        ];
      } else {
        finalResult = [
          {
            ...result2,
            status,
            Battery: 0,
            Email: "",
            signal: 0,
          },
        ];
      }

      return finalResult;
    } else {
      return [];
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getSnoozeStatus = async (dynamoDBClient, id = "", email = "") => {
  const params2 = {
    RequestItems: {
      SnoozeSettings: {
        Keys: [
          {
            Email: email,
            BeaconMAC: id,
          },
        ],
      },
    },
  };

  try {
    const data = await dynamoDBClient.batchGet(params2).promise();

    const arr = data.Responses.SnoozeSettings;
    if (arr.length === 0) {
      return "off";
    }
    const snooze = arr[0];
    const now = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
    const isBetween = moment(now).isBetween(
      snooze.SnoozeTimeStampStart,
      snooze.SnoozeTimeStampEnd
    );
    if (isBetween) {
      return "Snoozed";
    } else {
      return "off";
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getLatestBeaconRecords = async (
  dynamoDBClient,
  id = "",
  email = ""
) => {
  try {
    let lastEvaluatedKey = null;
    let result = [];
    do {
      const params = {
        TableName: "Notifications",
        KeyConditionExpression: "Email = :email",
        FilterExpression: "BeaconMAC = :beaconMac",
        ExpressionAttributeValues: {
          ":email": email,
          ":beaconMac": id,
        },
        ProjectionExpression:
          "NotificationTimeStamp, NotificationReason, RecordTimeStamp",
        ExculsiveStartKey: lastEvaluatedKey,
      };
      const data = await dynamoDBClient.query(params).promise();
      console.log(data);
      let arr = data.Items;
      lastEvaluatedKey = data.LastEvaluatedKey;
      arr = arr.sort((a, b) =>
        moment(b.NotificationTimeStamp).diff(a.NotificationTimeStamp)
      );
      result.push(...arr);
    } while (lastEvaluatedKey);

    return result;
  } catch (error) {
    throw new Error(error);
  }
};
export const getWarrantyData = async (dynamoDBClient, id = "") => {
  try {
    const params = {
      TableName: "BeaconData",
      FilterExpression: "BeaconMAC = :beaconMac",
      ExpressionAttributeValues: {
        ":beaconMac": id,
      },
    };
    const data = await dynamoDBClient.scan(params).promise();
    return "";
  } catch (error) {
    throw new Error(error);
  }
};
